import {BaseLinkModel} from "../../../infrastructure/models/link/base-link-model";
import {ROUTE_NAMES} from "../../../core/consts";
import {APP} from "../../../core/app/consts";
import {CompetitionLinkParams} from "./competition-link-params";

export class CompetitionLinkModel extends BaseLinkModel  {
  constructor(competitionId: Number, sportName: String, competitionName: String, isFollow: Boolean = true) {
    super(ROUTE_NAMES.competition, new CompetitionLinkParams(competitionId, sportName, competitionName), false, null, null);

    this.isFollow = isFollow;
    this.screen = APP.ANALYTICS.SOURCES.competition;
  }
}